import type { ButtonProps } from "@mui/material";
import { AppBar, Button, Toolbar, Typography } from "@mui/material";
// import { draftMode } from "next/headers";
import type { FC } from "react";

export const DraftMenu: FC<ButtonProps> = (props) => {
  // const { isEnabled: inDraftMode } = draftMode();
  // return inDraftMode
  //   ? (
  //     <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0 }}>
  //       <Toolbar variant="dense">
  //         <Button
  //           href="/api/draft/disable"
  //           size="large"
  //           variant="contained"
  //           fullWidth
  //           {...props}
  //         >
  //           Preview mode is on, &nbsp;
  //           <Typography sx={{ textDecoration: 'underline' }} display="inline">
  //             turn off
  //           </Typography>
  //         </Button>
  //       </Toolbar>
  //     </AppBar>
  //   )
  //   : null;
};
